import { Modal } from '@material-ui/core';
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import { COLORS } from '../components/PropertyDetailsCard';

const { width } = Dimensions.get('window');
import getPlatformType from "../../../../../helpers/helpers";
const layoutType = getPlatformType();
const DeletePopUp = ({ onClose, showModal, title, onSubmit }) => {
  return (
    <Modal
      open={showModal}
     
    >
      <View style={styles.overlay}>
        <View style={styles.popup}>
          <Text style={styles.title}>Are you sure?</Text>

          <Text style={styles.subtitle}>
            {title ? title : "Are you sure you want to remove this certificate?"}
          </Text>

          <View style={styles.buttonRow}>

            <TouchableOpacity onPress={onClose} style={styles.cancelButton}>
              <Text style={styles.cancelText}>Cancel</Text>
            </TouchableOpacity>

            <TouchableOpacity onPress={onSubmit} style={styles.okButton}>
              <Text style={styles.okText}>Delete</Text>
            </TouchableOpacity>

          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  overlay: {
    backgroundColor: "#fff",
    margin: "auto",
    marginTop: 100,
    width: layoutType=="web"? 500: "94%",
    borderRadius: 8,
    outline: "none",
  },

  popup: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 6,
  },

  title: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 10,
    color: "#111",
  },

  subtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 30,
    lineHeight: 22,
  },

  buttonRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  cancelButton: {
    flex: 1,
    marginRight: 10,
    paddingVertical: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#ccc",
    alignItems: "center",
  },

  okButton: {
    flex: 1,
    marginLeft: 10,
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: "#D64545", // nicer subtle danger color
    alignItems: "center",
  },

  cancelText: {
    fontSize: 16,
    color: "#333",
    fontWeight: "600",
  },

  okText: {
    fontSize: 16,
    color: "#fff",
    fontWeight: "700",
  },
});

export default DeletePopUp;
